import { h, FunctionComponent } from 'preact';

export type IconType =
  | 'a11y'
  | 'aria_editor'
  | 'check-circle'
  | 'check-in-circle'
  | 'check-v2'
  | 'chevron-right-v2'
  | 'close-small'
  | 'download'
  | 'pdf'
  | 'settings-v2'
  | 'spinner-v2'
  | 'target'
  | 'ai-chip-v2'
  | 'lst-flags'
  | 'external-link-icon'
  | 'user'
  | 'globe'
  | 'puzzle'
  | 'wrench';

type Props = {
  type: IconType;
};

export const Icon: FunctionComponent<Props> = ({ type }) => (
  <img role="presentation" alt="" src={`./frontend/images/${type}.svg`} />
);
